var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSemiFurnished(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1355 29.5726H30.6783V20.2663H33.1966V29.5824H35.0335V32.0714L33.8586 32.1544V35.8183H1.26207V32.1349H0.0407715V29.6166H1.84829V20.2614H4.33975V29.5433H16.8849V20.2492H18.1233L18.1355 29.5726Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0358887 3.86184V0.818359H35.031V3.86184H0.0358887Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3183 18.9327H1.41602L1.73111 17.726H33.353L33.6803 18.9473H27.5738C27.5738 20.1442 27.5738 21.2605 27.5738 22.367C27.5738 22.8555 27.5201 23.3244 26.9143 23.3025C26.372 23.2829 26.311 22.8359 26.3134 22.3816C26.3256 21.2751 26.3183 20.1588 26.3183 18.9327Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3628 5.19794C33.4653 5.60097 33.5631 5.97224 33.673 6.38748H1.43066L1.73843 5.19794H33.3628Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3603 7.71136L33.6681 8.89114H1.42578L1.72867 7.71136H33.3603Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.42334 11.3777L1.73599 10.2028H33.3481C33.4483 10.5717 33.5508 10.9356 33.6681 11.3777H1.42334Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3628 12.7211C33.4629 13.1144 33.5606 13.4881 33.6681 13.9058H1.42578L1.73355 12.7211H33.3628Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3628 15.2321C33.4605 15.6132 33.5582 15.9869 33.6681 16.4095H1.42578L1.72867 15.2321H33.3628Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemiFurnished);
export default __webpack_public_path__ + "static/media/semi-furnished.9a408ac6c1ec0742ae21a5eb56a1f916.svg";
export { ForwardRef as ReactComponent };